<template>
  <OButton pure class="u-center" v-bind="$attrs" v-on="$listeners">
    <div v-if="isReply" class="text-o-blue flex items-center">
      <div class="u-center w-5 h-5 rounded-md bg-o-blue mr-2">
        <OIcon icon="chevron-right-white" class="h-2.5 rotate-90" />
      </div>
      <span class="text-sm">{{ $t('comment-item.more-answers') }}</span>
    </div>
    <div v-else class="u-center w-48 h-9 bg-o-blue rounded-full text-white">
      <span class="text-sm">{{ $t('comment-item.more-comments') }}</span>
    </div>
  </OButton>
</template>

<script>
import { OButton, OIcon } from '~/modules/common/components/ui';
export default {
  components: { OButton, OIcon },
  props: {
    isReply: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
